export default __webpack_public_path__ + "static/media/chestc_bra.2c9fccef.webp";